// extracted by mini-css-extract-plugin
export default {"wrapper":"Modal_wrapper__BE2UA","modal":"Modal_modal__yEgVW","header":"Modal_header__uog9v","close":"Modal_close__nnot4","title":"Modal_title__KuCmT"};